export enum CalendarViewType {
  Month = 'Month',
  Week = 'Week',
}
